import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

import { roundNumber } from "@endgame/utils/roundNumber";

import { paintToSelectedFormat } from "../../../utils/colors.ts";

export const createDiamondGradient = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  paint: FigmaRestApi.GradientPaint,
) => {
  const { gradientStops } = paint;

  // Quadrant CSS values arrays for later interporlation
  const quadrantDenomination = [
    "top right",
    "bottom right",
    "bottom left",
    "top left",
  ];

  const gradients = Array.from(Array(4))
    .map((_, index) => {
      const colors = gradientStops
        .map((stop) => {
          const color = paintToSelectedFormat(
            stylesFormatsConfig.colors,
            stop.color,
          );
          const position = stop.position ?? 0;
          const positionOnDistance = roundNumber((position / 2) * 100, 2);
          return `${color} ${positionOnDistance}%`;
        })
        .join(", ");

      return `linear-gradient(to ${quadrantDenomination[index]}, ${colors}) ${quadrantDenomination[index]} / 50% 50% no-repeat`;
    })
    .join(", ");

  return gradients;
};
